import './external/global.js';
import './external/jquery.fancybox.min.js';
import './main/external/forms/index.js';
import './main/app.js';